/**
 * Where the contracts library lives in Google Drive.
 *
 * A plain constant rather than an environment variable because the frontend is built in a
 * Docker stage that receives no build args and no `.env`: a `VITE_`-prefixed variable would
 * be baked as empty. The same image is deployed to dev and prod, so anything the frontend
 * needs at build time has to be either in the source or fetched from the API at runtime.
 * This is one stable, non-secret id, so the source is the honest place for it. Changing it
 * is a one-line edit here.
 */
export const CONTRACTS_ROOT_FOLDER_ID = '1_Pisj3wpfeZfgnGOXNCSAeAjPYKX-kMI'

/** The contracts library itself: letter folders, then a folder per company. */
export function contractsRootUrl(): string {
  return `https://drive.google.com/drive/folders/${CONTRACTS_ROOT_FOLDER_ID}`
}

/**
 * NO WHOLE-DRIVE SEARCH FALLBACK, DELIBERATELY.
 *
 * The first version of this built `drive.google.com/drive/search?q="<company>"`, which
 * searches everything the viewer can see rather than the contracts library. A company name
 * that appears in an unrelated document came back alongside the contract, and a result list
 * that mixes the two is worse than no search: somebody opens the wrong file believing the
 * CRM pointed them at the right one.
 *
 * Drive's own UI can search within a folder, but the URL form for it is not documented and
 * could not be verified from here (it needs a signed-in Drive session). An unverified
 * search URL fails in the worst possible way: it quietly falls back to searching the whole
 * Drive, which is the exact bug being fixed, and looks like it worked.
 *
 * So the fallback opens the contracts library at its root and lets the person pick the
 * letter and the company. That is two clicks rather than one, but it is always correct and
 * never shows a document from somewhere else. The exact per-account link is what removes
 * those clicks, and recording one takes seconds.
 */
